<template lang="pug">
    form(v-if="validTekionLink" target="_blank" :action="tekionLink" method="get" enctype="application/x-www-form-urlencoded")
        v-btn(type="submit" color="var(--volie-blue)" small text)
            v-icon(dark small) mdi-open-in-new
            | Open in Tekion Scheduler
</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        computed: {
            validTekionLink() {
                return this.tekionLink?.length > 0;
            },
        },
        props: {
            tekionLink: String,
        },
    })
</script>

<style lang="scss" scoped>

</style>